<div id="nav-instruction-marker-component-container">
    <mat-icon *ngIf="markerIcon"
              [ngClass]="{'white-out-icon': !arrivedAtStop}"
              svgIcon="{{markerIcon}}"></mat-icon>
    <span> {{markerText}}</span>
</div>